module.exports = __webpack_public_path__ + "static/media/malaysia04.fe3c178e.jpg";